var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.823,
    height: 61.946,
    viewBox: "0 0 54.823 61.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(-0.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M24.828,0h8.6c3.886,0,5.237,1.25,5.609,5.119.27,2.923.27,2.906,3.142,2.94a22.638,22.638,0,0,1,3.024.3A3.272,3.272,0,0,1,48.176,11.4a57.966,57.966,0,0,1,.135,8.565c-.169,2.5-1.284,3.446-3.734,3.734-.98.118-1.5.473-1.639,1.47-.186,1.335-1.047,1.284-1.672.456-1.436-1.892-3.345-2.027-5.457-1.943-2.416.1-4.832-.017-7.247.017-1.926.017-2.821-1.2-3.463-2.754-.253-.591.287-1.6-.693-1.774a4.448,4.448,0,0,0-3.5.405c-.456.338-.845.777-1.267,1.149-1.47,1.284-1.774,1.233-2.382-.625-.287-.878-.878-.929-1.6-1.031C11.837,18.6,10.435,17,10.418,13.16c-.017-2.737-.034-5.474,0-8.21A4.744,4.744,0,0,1,15.469,0Z",
    transform: "translate(7.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M21.334,33.76c-4.477-6.369-4.544-11.251-.439-14.883a9.531,9.531,0,0,1,13.025.017c4.088,3.632,4,8.346-.321,14.715a8.151,8.151,0,0,1,5.744,4.561,13.91,13.91,0,0,1,1.183,9.106c-.456,2.365-1.858,3.413-4.325,3.413-5.795.017-11.572.017-17.367,0-2.7,0-4.038-.828-4.511-3.413-.828-4.612-.068-8.869,3.683-12.164A4.728,4.728,0,0,1,21.334,33.76Z",
    transform: "translate(9.667 11.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M15.588,40.075c-3.294.169-6.572-.253-9.9-.051-3.717.237-5.17-1.419-5.237-5.119C.383,30.429,1.921,27,6.3,25.209c1.216-.49.152-1-.152-1.368a7.648,7.648,0,0,1-1.2-8.548A8.007,8.007,0,1,1,18.7,23.333c-.963,1.3-.946,1.672.574,2.416,3.548,1.723,5.744,7.247,4.612,11.015a4.07,4.07,0,0,1-4.291,3.328C18.257,40.126,16.922,40.092,15.588,40.075Z",
    transform: "translate(0.31 7.278)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.af271855aec7fd3e7243c536151a0d5f.svg";
export { ForwardRef as ReactComponent };